function screenSliderInit() {
	if (window.innerWidth > 1023) {
		$(".product-screens__screens-container").slick({
			arrows: false,
			infinite: false,
			fade: true,
			speed: 1000,
			draggable: false,
		});

		setTimeout(function() {
			$(".product-screens__screens-container").removeClass(
				"slider-first-start"
			);
		}, 2000);

		var screenSliderControls = document.querySelectorAll(
			".product-screens__controls li"
		);
		var activeClass = "active";

		if (screenSliderControls.length > 0) {
			screenSliderControls[0].classList.add(activeClass);

			screenSliderControls.forEach(function(item, index) {
				item.addEventListener("click", function() {
					screenSliderControls.forEach(function(item) {
						item.classList.remove(activeClass);
					});
					item.classList.add(activeClass);

					$(".product-screens__screens-container").slick(
						"slickGoTo",
						index,
						false
					);
					$(".product-slider-nav").slick("slickGoTo", 0, false);
				});
			});
		}
	}
}
